import { showErrorMessage } from 'actions/messages';
import SubmittalPermissions from 'permissions/submittal-permissions';
import { submittalsApi } from 'services/api/submittals-api';
import { submittalAddlAssigneesApi } from 'services/api/submittal-addl-assignees-api';
import Submittal from 'domain/submittal';
import { analyzeSubmittalFiles } from 'services/api/agent-api';
import { csiCodesApi } from 'services/api/csi-codes-api';
import { directoryUsers } from 'services/utils/directory-util';
import {
  SUBMITTAL_LOG_INIT,
  SUBMITTALS_SET,
  SUBMITTAL_TAB_SELECTED_SET,
  SUBMITTAL_MODAL_SHOW_SET,
  SUBMITTAL_MODAL_INIT,
  SUBMITTAL_FORM_VALUE_UPDATE,
  SUBMITTAL_FILE_DELETE,
  SUBMITTAL_READ_ONLY_SET,
  SUBMITTAL_LEAD_TIME_READ_ONLY_SET,
  SUBMITTAL_GC_ACCELERATION_SET,
  SHOW_TRANSMITTAL_PDF_SET,
  TRANSMITTAL_PDF_SET,
  SUBMITTAL_FORM_SET,
  SUBMITTAL_FORM_ERRORS_SET,
  CURRENT_SUBMITTAL_SET,
  SUBMITTAL_UPDATE,
  SUBMITTAL_NOTES_SET,
  SUBMITTAL_NOTES_ADD,
  SUBMITTAL_LOG_PDF_VIEWER_SET,
  SUBMITTAL_LOG_PDF_SET,
  SUBMITTAL_PDF_VIEWER_SET,
  SUBMITTAL_SHOW_ERROR_MESSAGE_SET,
  SUBMITTAL_ADDL_ASSIGNEES_ADD,
  SUBMITTAL_ADDL_ASSIGNEES_UPDATE,
  SUBMITTAL_ADDL_ASSIGNEES_DELETE,
  SUBMITTAL_ADDL_ASSIGNEE_RESPONSE,
  SUBMITTALS_DELETE,
  SUBMITTAL_CREATED_REVISION_MODAL_SHOW_SET,
  REVISION_SUBMITTAL_SET,
  SUBMITTALS_RESPONSES_VIEW_MODAL_SET,
  SUBMITTALS_RESPONSE_MODAL_SET,
  AI_IMPORT_MODAL_SHOW,
  AI_IMPORT_SET_STEP,
  AI_IMPORT_SET_FILES,
  AI_IMPORT_SET_SUGGESTIONS,
  AI_IMPORT_SET_ANALYZE_ERROR,
  AI_IMPORT_UPDATE_SUGGESTION,
  AI_IMPORT_REMOVE_SUGGESTION,
  AI_IMPORT_TOGGLE_INCLUDE,
  AI_IMPORT_SET_RESULTS,
  AI_IMPORT_RESET,
} from 'components/admin/projects/details/project-submittal-log/store/action-types';
import { SubmittalStatusKeys } from 'domain/submittal-status-enum';
import User from 'domain/user';
import { uuidUtil } from 'services/utils/uuid-util.js';

export function initSubmittalLog() {
  return {
    type: SUBMITTAL_LOG_INIT,
  };
}

export function setSubmittalTabSelected(submittalTab) {
  return {
    type: SUBMITTAL_TAB_SELECTED_SET,
    payload: submittalTab,
  };
}

export function loadSubmittalsSuccess(
  submittalsData,
  page,
  status,
  dueDateFilter,
  tradeCodeFilter
) {
  return {
    type: SUBMITTALS_SET,
    payload: {
      ...submittalsData,
      currentPage: page,
      currentStatus: status,
      dueDateFilter,
      tradeCodeFilter,
    },
  };
}

export function loadSubmittalsRequest(
  projectId,
  page,
  status,
  dueDateFilter,
  tradeCodeFilter,
  searchText
) {
  return (dispatch) => {
    return submittalsApi
      .getSubmittals(
        projectId,
        page,
        status,
        searchText,
        dueDateFilter,
        tradeCodeFilter
      )
      .then((response) => {
        if (response.ok) {
          dispatch(
            loadSubmittalsSuccess(
              response,
              page,
              status,
              dueDateFilter,
              tradeCodeFilter
            )
          );
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function setSubmittalModalShow(show) {
  return {
    type: SUBMITTAL_MODAL_SHOW_SET,
    payload: show,
  };
}

export function setSubmittalResponseModalShow(show) {
  return {
    type: SUBMITTALS_RESPONSE_MODAL_SET,
    payload: show,
  };
}

export function setSubmittalResponsesViewModalShow(show) {
  return {
    type: SUBMITTALS_RESPONSES_VIEW_MODAL_SET,
    payload: show,
  };
}

export function initSubmittalModal() {
  return {
    type: SUBMITTAL_MODAL_INIT,
  };
}

export function updateSubmittalFormValue(attribute, value) {
  return {
    type: SUBMITTAL_FORM_VALUE_UPDATE,
    payload: { attribute: attribute, value: value },
  };
}

export function deleteSubmittalFile(attribute, value) {
  return {
    type: SUBMITTAL_FILE_DELETE,
    payload: { attribute: attribute, value: value },
  };
}

export function createSubmittal(projectId, values, page, status) {
  return (dispatch) => {
    return submittalsApi.createSubmittal(projectId, values).then((response) => {
      if (response.ok) {
        const submittal = response.submittal;
        dispatch(loadSubmittalsRequest(projectId, page, status));
        if (submittal.revised_submittal_id) {
          dispatch(loadRevisionSubmittalSuccess(submittal));
        }
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function setSubmittalReadOnly(readOnly) {
  return {
    type: SUBMITTAL_READ_ONLY_SET,
    payload: readOnly,
  };
}

export function setSubmittalLeadTimeReadOnly(leadTimeReadOnly) {
  return {
    type: SUBMITTAL_LEAD_TIME_READ_ONLY_SET,
    payload: leadTimeReadOnly,
  };
}

export function setSubmittalGcAcceleration(gcAcceleration) {
  return {
    type: SUBMITTAL_GC_ACCELERATION_SET,
    payload: gcAcceleration,
  };
}

export function setShowTransmittalPdf(showPdf) {
  return {
    type: SHOW_TRANSMITTAL_PDF_SET,
    payload: showPdf,
  };
}

export function setTransmittalPdf(pdf) {
  return {
    type: TRANSMITTAL_PDF_SET,
    payload: pdf,
  };
}

export function loadTransmittalPdf(projectId, submittalId) {
  return (dispatch) => {
    return submittalsApi
      .getTransmittalPdf(projectId, submittalId)
      .then((response) => {
        if (response.ok) {
          dispatch(setTransmittalPdf(response.transmittalPdf));
          dispatch(setShowTransmittalPdf(true));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function loadSubmittalSuccess(submittal) {
  return {
    type: CURRENT_SUBMITTAL_SET,
    payload: submittal,
  };
}

export function loadSubmittalRequest(projectId, submittalId, mapSubmittal) {
  return (dispatch) => {
    return submittalsApi
      .getSubmittal(projectId, submittalId)
      .then((response) => {
        if (response.ok) {
          if (mapSubmittal) {
            response.submittal = mapSubmittal(response.submittal);
          }
          dispatch(loadSubmittalSuccess(response.submittal));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function setSubmittalForm(form) {
  return {
    type: SUBMITTAL_FORM_SET,
    payload: form,
  };
}

export function startNewSubmittalWithPrefill(
  currentUser,
  currentProject,
  formPrefill = {}
) {
  return (dispatch) => {
    if (!SubmittalPermissions.canCreate(currentUser, currentProject)) {
      return;
    }
    dispatch(initSubmittalModal());
    const csiCodeId =
      formPrefill.csi_code_id != null
        ? formPrefill.csi_code_id
        : formPrefill.csi_code
        ? formPrefill.csi_code.id
        : null;
    const csiCodeLabel = formPrefill.csi_code
      ? formPrefill.csi_code.division
        ? formPrefill.csi_code.division + ' - ' + formPrefill.csi_code.label
        : formPrefill.csi_code.label
      : '';
    const assignee = Array.isArray(formPrefill.assignee)
      ? formPrefill.assignee
      : [];
    const recipients = Array.isArray(formPrefill.recipients)
      ? formPrefill.recipients
      : Array.isArray(formPrefill.recipient_ids)
      ? formPrefill.recipient_ids.map((id) => [id, String(id)])
      : [];
    const prefill = {
      title: formPrefill.title || '',
      question: formPrefill.question || '',
      dueDate: formPrefill.due_date || null,
      extendedDueDate: formPrefill.extended_due_date || null,
      assignee,
      recipients,
      csiCodeId,
      csiCodeLabel,
      status: SubmittalStatusKeys.PENDING,
      physicalCopies: '0',
      reqDocs: [],
      reqImages: [],
      reqDocsDelete: [],
      reqImagesDelete: [],
      addlAssignees: [],
      errors: {},
      uid: uuidUtil.uuidv4(),
    };
    dispatch(setSubmittalForm(prefill));
    dispatch(setSubmittalModalShow(true));
  };
}

export function setSubmittalFormErrors(errors) {
  return {
    type: SUBMITTAL_FORM_ERRORS_SET,
    payload: errors,
  };
}

export function updateSubmittalSuccess(submittal) {
  return {
    type: SUBMITTAL_UPDATE,
    payload: submittal,
  };
}

export function updateSubmittal(projectId, submittalId, values) {
  return (dispatch) => {
    return submittalsApi
      .updateSubmittal(projectId, submittalId, values)
      .then((response) => {
        if (response.ok) {
          dispatch(updateSubmittalSuccess(response.submittal));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function updateSubmittalLeadTime(projectId, submittalId, values) {
  return (dispatch) => {
    return submittalsApi
      .updateSubmittalLeadTime(projectId, submittalId, values)
      .then((response) => {
        if (response.ok) {
          dispatch(updateSubmittalSuccess(response.submittal));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function respondSubmittal(projectId, submittalId, values) {
  return (dispatch) => {
    return submittalsApi
      .respondSubmittal(projectId, submittalId, values)
      .then((response) => {
        if (response.ok) {
          dispatch(updateSubmittalSuccess(response.submittal));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function respondSubmittalAddlAssigneeSuccess(submittalAddlAssignee) {
  return {
    type: SUBMITTAL_ADDL_ASSIGNEE_RESPONSE,
    payload: submittalAddlAssignee,
  };
}

export function respondSubmittalAddlAssignee(id, values) {
  return (dispatch) => {
    return submittalAddlAssigneesApi
      .updateSubmittalAddlAssignee(id, values)
      .then((response) => {
        if (response.ok) {
          dispatch(
            respondSubmittalAddlAssigneeSuccess(response.submittalAddlAssignee)
          );
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function setSubmittalNotes(notes) {
  return {
    type: SUBMITTAL_NOTES_SET,
    payload: notes,
  };
}

export function clearSubmittalNotes() {
  return {
    type: SUBMITTAL_NOTES_SET,
    payload: [],
  };
}

export function loadSubmittalNotes(submittalId) {
  return (dispatch) => {
    return submittalsApi.getNotes(submittalId).then((response) => {
      if (response.ok) {
        dispatch(setSubmittalNotes(response.notes));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function markSubmittalNotesRead(submittalId, form, userId) {
  return (dispatch) => {
    return submittalsApi.markNotesRead(submittalId).then((response) => {
      if (response.ok) {
        const notesReadBy = form.notesReadBy.concat(userId.toString());
        dispatch(updateSubmittalFormValue('notesReadBy', notesReadBy));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function addSubmittalNote(note) {
  return {
    type: SUBMITTAL_NOTES_ADD,
    payload: note,
  };
}

export function createSubmittalNote(submittalId, content) {
  return (dispatch) => {
    return submittalsApi.createNote(submittalId, content).then((response) => {
      if (response.ok) {
        dispatch(addSubmittalNote(response.note));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function makeSubmittalForm(submittal) {
  return {
    ...submittal,
    submittedBy: submittal.submitted_by,
    csiCodeId: submittal.csi_code ? submittal.csi_code.id : null,
    csiCodeLabel: submittal.csi_code
      ? `${submittal.csi_code.division} - ${submittal.csi_code.label}`
      : '',
    contractorId: submittal.contractor_id || '',
    physicalCopies: (submittal.physical_copies || 0).toString(),
    assignee: submittal.assignee
      ? [submittal.assignee.id, User.fullNameWithCompany(submittal.assignee)]
      : [],
    recipients: submittal.recipients.map((rcpt) => [
      rcpt.id,
      User.fullNameWithCompany(rcpt),
    ]),
    requestedDate: submittal.requested_at,
    dueDate: submittal.due_date,
    extendedDueDate: submittal.extended_due_date,
    stampAction: submittal.stamp_action,
    notesReadBy: submittal.notes_read_by,
    leadTimeApplies: submittal.lead_time_applies,
    leadTimeWeeks:
      submittal.lead_time_weeks !== null
        ? submittal.lead_time_weeks.toString()
        : '',
    orderDate: submittal.order_date,
    vendorDelivery: submittal.vendor_delivery,
    fieldDelivery: submittal.field_delivery,
    leadTimeReminder: submittal.lead_time_reminder,
    reqImages: [],
    reqImagesDelete: [],
    reqDocs: [],
    reqDocsDelete: [],
    resImages: [],
    resImagesDelete: [],
    resDocs: [],
    resDocsDelete: [],
    addlAssignees: submittal.submittal_addl_assignees.map((addlAssignee) => {
      return {
        id: addlAssignee.id,
        assigneeId: addlAssignee.assignee_id,
        assigneeLabel: User.fullNameWithCompany(addlAssignee.assignee),
        dueDate: addlAssignee.due_date,
        returnedAt: addlAssignee.returned_at,
        stampAction: addlAssignee.stamp_action,
        stampTitle: addlAssignee.stamp_title,
      };
    }),
    errors: {},
  };
}

export function setCurrentSubmittal(submittal) {
  return (dispatch) => {
    dispatch(setSubmittalForm(makeSubmittalForm(submittal)));
  };
}

export function openSubmittal(projectId, submittalId, user) {
  return (dispatch) => {
    dispatch(initSubmittalModal());
    dispatch(loadSubmittalRequest(projectId, submittalId)).then((response) => {
      if (response.ok) {
        const { submittal } = response;
        const readOnly = Submittal.readOnly(submittal, user);

        dispatch(setCurrentSubmittal(submittal));
        dispatch(setSubmittalReadOnly(readOnly));
        dispatch(setSubmittalLeadTimeReadOnly(true));
        dispatch(setSubmittalModalShow(true));
      }
    });
  };
}

export function makeRevisedSubmittal(submittal) {
  return {
    ...submittal,
    newRevision: true,
    revised_submittal_id: submittal.id,
    status: SubmittalStatusKeys.PENDING,
    closed: false,
    submitted_by: null,
    submitted_at: null,
    responded_by: null,
    stamp_action: null,
    stamp_title: null,
    response_documents: [],
    response_images: [],
    remarks: null,
    submittal_addl_assignees: submittal.submittal_addl_assignees.map(
      (addlAssignee) => ({
        ...addlAssignee,
        id: null,
        stamp_action: null,
        stamp_title: null,
        response_documents: [],
        response_images: [],
      })
    ),
  };
}

export function reviseSubmittal(projectId, submittalId, user) {
  return (dispatch) => {
    dispatch(initSubmittalModal());
    dispatch(
      loadSubmittalRequest(projectId, submittalId, makeRevisedSubmittal)
    ).then((response) => {
      if (response.ok) {
        const { submittal } = response;
        dispatch(setCurrentSubmittal(submittal));
        dispatch(setSubmittalModalShow(true));
      }
    });
  };
}

export function setSubmittalLogPdfViewer(pdfViewer) {
  return {
    type: SUBMITTAL_LOG_PDF_VIEWER_SET,
    payload: pdfViewer,
  };
}

export function loadSubmittalLogPdfSuccess(submittalLogPdf) {
  return {
    type: SUBMITTAL_LOG_PDF_SET,
    payload: submittalLogPdf,
  };
}

export function loadSubmittalLogPdfRequest(projectId, status) {
  return (dispatch) => {
    return submittalsApi
      .getSubmittalLogPdf(projectId, status)
      .then((response) => {
        if (response.ok) {
          dispatch(loadSubmittalLogPdfSuccess(response.submittalLogPdf));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function loadSubmittalLeadTimeLogPdfRequest(projectId) {
  return (dispatch) => {
    return submittalsApi
      .getSubmittalLeadTimeLogPdf(projectId)
      .then((response) => {
        if (response.ok) {
          dispatch(
            loadSubmittalLogPdfSuccess(response.submittalLeadTimeLogPdf)
          );
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function setSubmittalPdfViewer(pdfViewer) {
  return {
    type: SUBMITTAL_PDF_VIEWER_SET,
    payload: pdfViewer,
  };
}

export function setSetShowSubmittalErrorMessage(showErrorMessage) {
  return {
    type: SUBMITTAL_SHOW_ERROR_MESSAGE_SET,
    payload: showErrorMessage,
  };
}

export function addSubmittalAddlAssignee(addlAssignee) {
  return {
    type: SUBMITTAL_ADDL_ASSIGNEES_ADD,
    payload: addlAssignee,
  };
}

export function updateSubmittalAddlAssignee(addlAssignee, index) {
  return {
    type: SUBMITTAL_ADDL_ASSIGNEES_UPDATE,
    payload: { addlAssignee, index },
  };
}

export function deleteSubmittalAddlAssignee(index) {
  return {
    type: SUBMITTAL_ADDL_ASSIGNEES_DELETE,
    payload: index,
  };
}

// --- AI Bulk Import ---

export function openAIImportModal() {
  return { type: AI_IMPORT_MODAL_SHOW, payload: true };
}

export function closeAIImportModal() {
  return { type: AI_IMPORT_MODAL_SHOW, payload: false };
}

export function setAIImportStep(step) {
  return { type: AI_IMPORT_SET_STEP, payload: step };
}

export function setAIImportFiles(files) {
  return { type: AI_IMPORT_SET_FILES, payload: files };
}

export function setAIImportSuggestions(suggestions) {
  return { type: AI_IMPORT_SET_SUGGESTIONS, payload: suggestions };
}

export function setAIImportAnalyzeError(error) {
  return { type: AI_IMPORT_SET_ANALYZE_ERROR, payload: error };
}

export function updateAIImportSuggestion(uid, field, value) {
  return { type: AI_IMPORT_UPDATE_SUGGESTION, payload: { uid, field, value } };
}

export function removeAIImportSuggestion(uid) {
  return { type: AI_IMPORT_REMOVE_SUGGESTION, payload: uid };
}

export function toggleAIImportInclude(uid) {
  return { type: AI_IMPORT_TOGGLE_INCLUDE, payload: uid };
}

export function setAIImportResults(results) {
  return { type: AI_IMPORT_SET_RESULTS, payload: results };
}

export function resetAIImport() {
  return { type: AI_IMPORT_RESET };
}

export function analyzeFiles(
  projectId,
  files,
  authHeaders,
  directory,
  page,
  status
) {
  return (dispatch) => {
    dispatch(setAIImportStep('analyzing'));
    dispatch(setAIImportAnalyzeError(null));
    const { accessToken, client, uid } = authHeaders;
    return Promise.all([
      analyzeSubmittalFiles(projectId, files, accessToken, client, uid),
      csiCodesApi.getCsiCodes(),
    ]).then(([agentResponse, csiResponse]) => {
      if (!agentResponse.ok) {
        const errMsg =
          agentResponse.errors && agentResponse.errors.length > 0
            ? agentResponse.errors.join(', ')
            : 'Analysis failed';
        dispatch(setAIImportAnalyzeError(errMsg));
        dispatch(setAIImportStep('upload'));
        return;
      }
      const members = directoryUsers(directory);
      const csiCodes = csiResponse.ok ? csiResponse.csiCodes : [];
      const raw = agentResponse.data.submittals || [];
      const suggestions = raw.map((s) => {
        const assigneeName = (s.assignee_name || '').toLowerCase();
        const assigneeUser = members.find(
          (m) =>
            (m.first_name + ' ' + m.last_name).toLowerCase() === assigneeName
        );
        const csiCode = csiCodes.find(
          (c) =>
            c.label === s.csi_code ||
            c.division === s.csi_code ||
            String(c.id) === String(s.csi_code_id)
        );
        return {
          uid: uuidUtil.uuidv4(),
          include: true,
          title: s.title || '',
          question: s.question || '',
          csi_code_id: csiCode ? csiCode.id : s.csi_code_id || null,
          assignee_id: assigneeUser ? assigneeUser.id : null,
          status: s.status || null,
          requested_at: s.requested_at || null,
          due_date: s.due_date || null,
          extended_due_date: s.extended_due_date || null,
          source_file: s.source_file || null,
        };
      });
      dispatch(setAIImportSuggestions(suggestions));
      dispatch(
        bulkCreateSuggestions(projectId, suggestions, files, page, status)
      );
    });
  };
}

export function bulkCreateSuggestions(
  projectId,
  suggestions,
  files,
  page,
  status
) {
  return (dispatch) => {
    dispatch(setAIImportStep('creating'));
    const included = suggestions.filter((s) => s.include);
    const tasks = included.map((s) => {
      const sourceFile = files.find((f) => f.name === s.source_file) || null;
      const values = {
        title: s.title,
        status: SubmittalStatusKeys.DRAFT,
        csiCodeId: s.csi_code_id || null,
        assigneeId: s.assignee_id || null,
        requestedAt: s.requested_at || null,
        dueDate: s.due_date || null,
        extendedDueDate: s.extended_due_date || null,
        question: s.question || '',
        physicalCopies: '0',
        uid: uuidUtil.uuidv4(),
        addlAssignees: [],
        recipientIds: [],
        reqImages: [],
        reqImagesDelete: [],
        reqDocs: sourceFile ? [{ file: sourceFile }] : [],
        reqDocsDelete: [],
      };
      return submittalsApi.createSubmittal(projectId, values);
    });
    return Promise.allSettled(tasks).then((results) => {
      const created = results.filter(
        (r) => r.status === 'fulfilled' && r.value && r.value.ok
      ).length;
      const failed = results.length - created;
      dispatch(setAIImportResults({ created, failed }));
      dispatch(loadSubmittalsRequest(projectId, page, status));
      dispatch(setAIImportStep('done'));
    });
  };
}

export function deleteSubmittalSuccess(submittalId) {
  return {
    type: SUBMITTALS_DELETE,
    payload: submittalId,
  };
}

export function deleteSubmittal(projectId, submittalId) {
  return (dispatch) => {
    return submittalsApi
      .deleteSubmittal(projectId, submittalId)
      .then((response) => {
        if (response.ok) {
          dispatch(deleteSubmittalSuccess(submittalId));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function setSubmittalCreatedRevisionModalShow(show) {
  return {
    type: SUBMITTAL_CREATED_REVISION_MODAL_SHOW_SET,
    payload: show,
  };
}

export function loadRevisionSubmittalSuccess(submittal) {
  return {
    type: REVISION_SUBMITTAL_SET,
    payload: submittal,
  };
}

export function loadCreatedRevisionSubmittalRequest(projectId, submittalId) {
  return (dispatch) => {
    return submittalsApi
      .getSubmittal(projectId, submittalId)
      .then((response) => {
        if (response.ok) {
          dispatch(loadRevisionSubmittalSuccess(response.submittal));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}
